import { useEffect } from 'react'
import { PageHeader } from '@/components/PageHeader'
import { useAnalyticsView } from '@/features/amplitude'
import { UpriseIframe } from '../UpriseIframe'

export const FinancialAdvisoryInbox = () => {
  const pageView = useAnalyticsView()
  useEffect(() => {
    pageView('advisory inbox panel')
  }, [pageView])

  return (
    <>
      <PageHeader header="Financial Advisory" />
      <UpriseIframe page="inbox" />
    </>
  )
}
